var _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 190,
    viewBox: "0 0 156 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.076 8.14069C59.9575 9.30637 95.8075 9.78356 127.677 11.265C129.173 11.335 130.567 13.8872 130.605 15.3579L133.817 137.563C133.831 138.366 133.527 139.141 132.971 139.72C132.415 140.298 131.652 140.633 130.849 140.65C117.053 141.066 60.2471 142.58 40.0733 139.937C39.4854 139.865 38.9451 139.577 38.556 139.131C38.1669 138.684 37.9565 138.109 37.9651 137.517L40.7297 10.8709C40.7736 9.14968 42.3287 8.01249 44.076 8.14069Z",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.076 8.14069C59.9575 9.30637 95.8075 9.78356 127.677 11.265C129.173 11.335 130.567 13.8872 130.605 15.3579L133.817 137.563C133.831 138.366 133.527 139.141 132.971 139.72C132.415 140.298 131.652 140.633 130.849 140.65C117.053 141.066 60.2471 142.58 40.0733 139.937C39.4854 139.865 38.9451 139.577 38.556 139.131C38.1669 138.684 37.9565 138.109 37.9651 137.517L40.7297 10.8709C40.7736 9.14968 42.3287 8.01249 44.076 8.14069Z",
    fill: "url(#paint0_linear_2420_29580)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M44.8946 10.3017C59.4952 10.9582 95.8082 11.5458 125.836 12.6343C128.328 12.7245 128.166 17.2471 128.203 18.6621L131.257 134.851C131.27 135.623 130.977 136.369 130.442 136.926C129.906 137.482 129.172 137.803 128.4 137.819C115.125 138.22 60.4567 139.678 41.0426 137.134C40.4768 137.064 39.9568 136.788 39.5824 136.358C39.208 135.928 39.0055 135.375 39.0139 134.805L41.6753 12.9287C41.7109 11.2727 43.2101 10.2258 44.8946 10.3017Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4281 47.5577C47.3661 47.5568 47.3045 47.5686 47.2472 47.5923C47.1899 47.616 47.1379 47.6512 47.0946 47.6956C47.0513 47.74 47.0175 47.7928 46.9952 47.8507C46.973 47.9086 46.9628 47.9705 46.9652 48.0325L47.0281 50.5787C47.0315 50.7056 47.0842 50.8262 47.1751 50.9148C47.266 51.0035 47.3878 51.0533 47.5148 51.0535L121.933 50.714C121.994 50.7141 122.055 50.7017 122.112 50.6776C122.168 50.6534 122.219 50.6181 122.261 50.5737C122.303 50.5293 122.336 50.4767 122.358 50.4192C122.379 50.3617 122.388 50.3005 122.385 50.2392L122.303 48.5773C122.295 48.4502 122.24 48.3307 122.148 48.2427C122.055 48.1547 121.934 48.1047 121.806 48.1025L47.4281 47.5577Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8824 59.0215C47.8203 59.0208 47.7588 59.0327 47.7015 59.0565C47.6441 59.0803 47.5922 59.1154 47.5488 59.1598C47.5055 59.2041 47.4715 59.2568 47.4491 59.3147C47.4266 59.3725 47.4161 59.4343 47.4182 59.4963L47.4823 62.0425C47.4857 62.1695 47.5385 62.29 47.6293 62.3787C47.7202 62.4674 47.8421 62.5171 47.969 62.5174L122.387 62.1684C122.449 62.1685 122.509 62.1561 122.566 62.1319C122.622 62.1078 122.673 62.0724 122.715 62.028C122.757 61.9835 122.79 61.931 122.811 61.8735C122.832 61.816 122.842 61.7548 122.838 61.6936L122.758 60.0317C122.749 59.9046 122.693 59.7854 122.601 59.6976C122.508 59.6097 122.387 59.5595 122.259 59.5569L47.8824 59.0215Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.7953 70.7041C47.7333 70.7034 47.6718 70.7154 47.6145 70.7391C47.5573 70.7629 47.5054 70.798 47.4622 70.8424C47.4189 70.8868 47.3851 70.9395 47.3627 70.9974C47.3404 71.0552 47.3301 71.117 47.3323 71.1789L47.3964 73.7252C47.3998 73.8521 47.4526 73.9727 47.5434 74.0613C47.6343 74.15 47.7562 74.1997 47.8831 74.2L122.301 73.8605C122.363 73.8607 122.424 73.8485 122.48 73.8244C122.536 73.8003 122.587 73.7649 122.63 73.7205C122.672 73.676 122.704 73.6234 122.726 73.5658C122.747 73.5082 122.756 73.4469 122.753 73.3857L122.672 71.7238C122.663 71.5966 122.607 71.4773 122.515 71.3894C122.423 71.3015 122.301 71.2514 122.173 71.249L47.7953 70.7041Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2504 82.168C48.1884 82.1672 48.1268 82.179 48.0695 82.2027C48.0121 82.2264 47.9602 82.2615 47.9169 82.3059C47.8736 82.3504 47.8398 82.4032 47.8175 82.4611C47.7953 82.519 47.785 82.5808 47.7875 82.6428L47.8504 85.189C47.8538 85.316 47.9065 85.4366 47.9974 85.5252C48.0883 85.6139 48.2101 85.6636 48.3371 85.6639L122.755 85.3161C122.817 85.316 122.877 85.3035 122.934 85.2793C122.99 85.2551 123.041 85.2197 123.083 85.1754C123.125 85.131 123.158 85.0785 123.18 85.0211C123.201 84.9636 123.211 84.9025 123.208 84.8412L123.126 83.1794C123.117 83.0523 123.062 82.933 122.97 82.845C122.877 82.7571 122.756 82.707 122.628 82.7046L48.2504 82.168Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4203 91.7071C47.3583 91.7062 47.2967 91.718 47.2394 91.7417C47.182 91.7654 47.1301 91.8006 47.0868 91.845C47.0435 91.8894 47.0097 91.9422 46.9874 92.0001C46.9652 92.058 46.955 92.1199 46.9574 92.1819L47.0203 94.7281C47.0237 94.855 47.0764 94.9756 47.1673 95.0643C47.2582 95.1529 47.38 95.2027 47.507 95.2029L121.925 94.8634C121.987 94.8637 122.047 94.8514 122.104 94.8273C122.16 94.8032 122.211 94.7679 122.253 94.7234C122.296 94.6789 122.328 94.6263 122.349 94.5687C122.371 94.5111 122.38 94.4499 122.376 94.3886L122.296 92.7268C122.287 92.5997 122.232 92.4803 122.14 92.3924C122.047 92.3045 121.926 92.2543 121.798 92.2519L47.4203 91.7071Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8734 103.17C47.8114 103.169 47.7499 103.181 47.6927 103.205C47.6354 103.229 47.5836 103.264 47.5403 103.308C47.497 103.353 47.4632 103.405 47.4409 103.463C47.4186 103.521 47.4082 103.583 47.4105 103.645L47.4746 106.191C47.478 106.318 47.5307 106.438 47.6216 106.527C47.7124 106.616 47.8343 106.666 47.9612 106.666L122.378 106.327C122.44 106.328 122.501 106.315 122.557 106.291C122.614 106.267 122.664 106.232 122.707 106.188C122.749 106.143 122.782 106.09 122.803 106.033C122.825 105.975 122.834 105.914 122.831 105.853L122.75 104.191C122.741 104.064 122.685 103.945 122.593 103.857C122.501 103.769 122.379 103.719 122.251 103.716L47.8734 103.17Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4203 113.497C47.3583 113.496 47.2967 113.508 47.2394 113.532C47.182 113.555 47.1301 113.591 47.0868 113.635C47.0435 113.679 47.0097 113.732 46.9874 113.79C46.9652 113.848 46.955 113.91 46.9574 113.972L47.0203 116.518C47.0237 116.645 47.0764 116.766 47.1673 116.854C47.2582 116.943 47.38 116.993 47.507 116.993L121.925 116.653C121.987 116.654 122.047 116.641 122.104 116.617C122.16 116.593 122.211 116.558 122.253 116.513C122.296 116.469 122.328 116.416 122.349 116.359C122.371 116.301 122.38 116.24 122.376 116.179L122.296 114.517C122.287 114.39 122.232 114.27 122.14 114.182C122.047 114.095 121.926 114.044 121.798 114.042L47.4203 113.497Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.1914 36.551C48.1334 36.5463 48.0752 36.5555 48.0214 36.5777C47.9677 36.5999 47.92 36.6346 47.8824 36.6789C47.8447 36.7232 47.8181 36.7758 47.8047 36.8324C47.7914 36.889 47.7917 36.948 47.8056 37.0045L48.2614 39.3881C48.29 39.5174 48.361 39.6335 48.4632 39.7178C48.5654 39.8021 48.6928 39.8499 48.8253 39.8534L72.2872 39.7465C72.3491 39.7462 72.4102 39.7337 72.4672 39.7096C72.5241 39.6855 72.5757 39.6504 72.619 39.6062C72.6622 39.562 72.6963 39.5097 72.7193 39.4523C72.7422 39.3949 72.7535 39.3335 72.7526 39.2717L72.7217 37.7428C72.7176 37.6154 72.6656 37.4942 72.576 37.4035C72.4864 37.3129 72.3659 37.2594 72.2386 37.2537L48.1914 36.551Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.8259 37.5478L78.7796 39.377C78.7774 39.4389 78.7877 39.5006 78.8099 39.5583C78.8321 39.6161 78.8659 39.6688 78.909 39.7131C78.9522 39.7575 79.0039 39.7927 79.061 39.8165C79.1181 39.8404 79.1795 39.8524 79.2414 39.8519L120.907 39.6619C120.968 39.6618 121.029 39.6493 121.086 39.6252C121.143 39.6011 121.194 39.5659 121.237 39.5216C121.28 39.4773 121.313 39.4249 121.335 39.3675C121.358 39.31 121.368 39.2487 121.366 39.1871L121.319 37.6582C121.311 37.5319 121.257 37.413 121.166 37.325C121.075 37.237 120.955 37.1865 120.828 37.1834L79.842 36.5792C79.5797 36.5759 79.3265 36.6754 79.1366 36.8565C78.9467 37.0375 78.8352 37.2856 78.8259 37.5478Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.7694 121.928C94.7083 121.926 94.6476 121.938 94.591 121.961C94.5345 121.984 94.4834 122.019 94.4409 122.063C94.3984 122.107 94.3655 122.159 94.3442 122.216C94.3229 122.273 94.3137 122.335 94.3171 122.396L94.4109 124.34C94.4176 124.468 94.4728 124.588 94.5652 124.676C94.6577 124.764 94.7804 124.814 94.9083 124.815L121.076 124.696C121.137 124.696 121.198 124.683 121.255 124.659C121.312 124.635 121.364 124.6 121.407 124.556C121.45 124.511 121.484 124.459 121.507 124.402C121.53 124.344 121.541 124.283 121.54 124.221L121.51 122.822C121.506 122.695 121.453 122.574 121.363 122.484C121.273 122.395 121.152 122.343 121.024 122.34L94.7694 121.928Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1162 0.550935C79.0432 0.548574 78.9741 0.517295 78.9241 0.463979C78.8741 0.410663 78.8474 0.339675 78.8498 0.266635C78.8521 0.193596 78.8834 0.124489 78.9367 0.0745119C78.99 0.024535 79.061 -0.00221716 79.1341 0.000144019L80.4398 0.0369422C80.4761 0.0375508 80.5118 0.0453796 80.5451 0.0599709C80.5783 0.0745622 80.6082 0.0956226 80.6332 0.121924C80.6582 0.148226 80.6777 0.179243 80.6905 0.213159C80.7034 0.247075 80.7093 0.283211 80.7081 0.31946C80.7071 0.355732 80.6991 0.391462 80.6843 0.424602C80.6695 0.457741 80.6483 0.487636 80.622 0.512565C80.5956 0.537494 80.5646 0.556967 80.5307 0.569867C80.4968 0.582767 80.4606 0.58884 80.4244 0.587733L79.1186 0.55212L79.1162 0.550935Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.813 131.864C114.992 131.864 113.212 131.324 111.698 130.312C110.184 129.3 109.003 127.862 108.306 126.18C107.609 124.497 107.427 122.646 107.782 120.86C108.138 119.074 109.015 117.433 110.302 116.145C111.59 114.857 113.231 113.98 115.017 113.625C116.803 113.27 118.655 113.452 120.337 114.149C122.02 114.846 123.458 116.026 124.47 117.541C125.481 119.055 126.021 120.835 126.021 122.656C126.019 125.097 125.048 127.438 123.322 129.164C121.595 130.891 119.255 131.862 116.813 131.864ZM116.813 113.923C115.086 113.923 113.398 114.435 111.962 115.395C110.525 116.354 109.406 117.718 108.745 119.314C108.084 120.91 107.911 122.666 108.248 124.36C108.585 126.054 109.417 127.61 110.638 128.831C111.859 130.053 113.416 130.884 115.11 131.221C116.804 131.558 118.56 131.385 120.155 130.724C121.751 130.064 123.115 128.944 124.075 127.508C125.034 126.072 125.546 124.383 125.546 122.656C125.544 120.341 124.623 118.121 122.986 116.484C121.349 114.846 119.129 113.926 116.813 113.923Z",
    fill: "url(#paint1_linear_2420_29580)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.794 129.754C115.386 129.754 114.008 129.337 112.837 128.554C111.666 127.771 110.753 126.659 110.214 125.358C109.675 124.056 109.534 122.624 109.809 121.243C110.084 119.861 110.762 118.592 111.758 117.596C112.754 116.6 114.023 115.921 115.405 115.647C116.786 115.372 118.218 115.513 119.52 116.052C120.821 116.591 121.934 117.504 122.716 118.675C123.499 119.846 123.916 121.223 123.916 122.632C123.914 124.52 123.163 126.331 121.828 127.666C120.493 129.001 118.682 129.752 116.794 129.754ZM116.794 115.747C115.432 115.747 114.101 116.151 112.969 116.907C111.837 117.664 110.954 118.739 110.433 119.997C109.912 121.255 109.776 122.64 110.042 123.975C110.307 125.311 110.963 126.538 111.926 127.5C112.889 128.463 114.115 129.119 115.451 129.385C116.787 129.65 118.171 129.514 119.429 128.993C120.687 128.472 121.762 127.589 122.519 126.457C123.275 125.325 123.679 123.994 123.679 122.632C123.677 120.807 122.951 119.057 121.66 117.766C120.369 116.475 118.619 115.749 116.794 115.747Z",
    fill: "url(#paint2_linear_2420_29580)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7605 24.1781C79.5505 24.4581 80.0405 25.0581 80.0405 25.9081C80.0405 27.1181 79.0405 27.8281 77.1605 27.8281H73.3805V20.8281H76.9605C78.8005 20.8281 79.7005 21.5781 79.7005 22.6581C79.7005 23.3281 79.3605 23.8681 78.7605 24.1781ZM76.7005 22.2581H75.3405V23.6081H76.7005C77.3605 23.6081 77.7005 23.3781 77.7005 22.9281C77.7005 22.4881 77.3605 22.2581 76.7005 22.2581ZM77.0005 26.3981C77.6805 26.3981 78.0405 26.1681 78.0405 25.6881C78.0405 25.2081 77.6805 24.9781 77.0005 24.9781H75.3405V26.3981H77.0005ZM81.0661 27.8281V20.8281H83.0461V26.2581H86.3861V27.8281H81.0661ZM90.5922 27.9681C88.3522 27.9681 86.7022 26.4281 86.7022 24.3281C86.7022 22.2281 88.3522 20.6881 90.5922 20.6881C92.8322 20.6881 94.4822 22.2281 94.4822 24.3281C94.4822 26.4281 92.8322 27.9681 90.5922 27.9681ZM90.5922 26.3281C91.6522 26.3281 92.4822 25.5381 92.4822 24.3281C92.4822 23.1181 91.6522 22.3281 90.5922 22.3281C89.5322 22.3281 88.7022 23.1181 88.7022 24.3281C88.7022 25.5381 89.5322 26.3281 90.5922 26.3281ZM100.209 26.0981V24.1781H101.959V27.0781C101.149 27.6581 100.039 27.9681 99.0192 27.9681C96.7892 27.9681 95.1592 26.4581 95.1592 24.3281C95.1592 22.1981 96.7892 20.6881 99.0592 20.6881C100.369 20.6881 101.429 21.1381 102.119 21.9681L100.859 23.1081C100.379 22.5781 99.8292 22.3281 99.1592 22.3281C97.9592 22.3281 97.1592 23.1181 97.1592 24.3281C97.1592 25.5081 97.9592 26.3281 99.1392 26.3281C99.5092 26.3281 99.8592 26.2581 100.209 26.0981Z",
    fill: "#D86A82"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4147 33.8967C48.4598 34.038 47.9399 34.2528 47.6396 33.6736C47.6289 33.3958 47.4591 32.2064 47.6253 31.9796C48.5097 30.7748 50.2238 29.2637 50.2238 29.2637C50.3044 29.3327 50.3549 29.4306 50.3645 29.5364C50.374 29.6422 50.3418 29.7475 50.2748 29.8299L49.4439 30.6964C49.6172 31.011 49.8297 31.2757 49.9294 31.6556C50.0009 31.9463 49.9584 32.2534 49.8107 32.5138C49.6647 32.7761 49.4652 33.118 49.2765 33.3863C49.1804 33.5307 49.0531 33.6515 48.9039 33.7399C48.7547 33.8283 48.5875 33.8819 48.4147 33.8967Z",
    fill: "url(#paint3_linear_2420_29580)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0799 31.2578L48.3214 31.8988L48.084 32.5375L48.7606 33.2877C48.7606 33.2877 48.9873 32.0187 49.1559 31.7445C49.3245 31.4703 49.2366 31.3385 49.0799 31.2578Z",
    fill: "url(#paint4_linear_2420_29580)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5318 81.207C33.5318 81.207 33.3407 82.2908 33.2469 83.3639C33.2383 83.4633 33.25 83.5634 33.2812 83.6582C33.3125 83.753 33.3626 83.8404 33.4287 83.9152C33.4947 83.99 33.5752 84.0506 33.6654 84.0934C33.7556 84.1361 33.8535 84.1602 33.9532 84.164C35.3776 84.2233 38.4378 84.3396 39.5323 84.291C39.571 84.29 39.6088 84.2796 39.6425 84.2606C39.6763 84.2416 39.7049 84.2147 39.7258 84.1822C39.7468 84.1496 39.7594 84.1125 39.7627 84.0739C39.766 84.0354 39.7599 83.9966 39.7448 83.961C39.6935 83.8327 39.5949 83.729 39.4694 83.6713L34.4221 81.3507L33.5318 81.207Z",
    fill: "url(#paint5_linear_2420_29580)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M33.373 80.5672L33.5309 81.8658C33.5309 81.8658 34.4153 82.2777 35.0195 81.8148L34.6539 80.3701L33.373 80.5672Z",
    fill: "url(#paint6_linear_2420_29580)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4888 56.1973C33.4223 56.5356 33.1326 73.0913 34.9025 80.5104C34.9171 80.5691 34.9101 80.631 34.8829 80.6851C34.8557 80.7391 34.81 80.7815 34.7541 80.8047C34.2938 80.9832 33.8065 81.0824 33.3131 81.0979C33.217 81.1007 33.1228 81.0717 33.0449 81.0155C32.967 80.9593 32.9098 80.8789 32.8822 80.7869C32.3765 79.0645 29.9525 70.4406 29.6368 62.2013C29.2807 52.9958 29.6368 61.888 29.6368 61.888L29.8433 56.1973H33.4888Z",
    fill: "url(#paint7_linear_2420_29580)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7222 81.7725C27.7222 81.7725 27.4172 82.3197 27.1204 83.7726C27.1078 83.8346 27.1083 83.8984 27.1219 83.9601C27.1355 84.0219 27.1619 84.08 27.1994 84.1309C27.2369 84.1818 27.2846 84.2243 27.3395 84.2556C27.3944 84.2869 27.4552 84.3064 27.5181 84.3127C27.9929 84.359 28.7158 84.4184 29.2986 84.4148C29.362 84.4146 29.4246 84.401 29.4823 84.3749C29.54 84.3488 29.5916 84.3108 29.6336 84.2634C29.6756 84.216 29.7071 84.1602 29.7261 84.0998C29.7451 84.0394 29.7511 83.9756 29.7438 83.9127C29.6797 83.3821 29.4791 82.512 28.8582 81.833L27.7222 81.7725Z",
    fill: "url(#paint8_linear_2420_29580)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4551 80.1043L27.8112 82.0653C27.8112 82.0653 28.1673 82.33 28.87 82.1377L28.6979 80.0283L27.4551 80.1043Z",
    fill: "url(#paint9_linear_2420_29580)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4827 56.7074C25.0357 65.4417 26.7973 78.2962 27.3908 80.8128C27.4087 80.888 27.4483 80.9563 27.5046 81.0093C27.5609 81.0622 27.6316 81.0975 27.7077 81.1107C28.084 81.1778 28.4704 81.1624 28.8402 81.0656C28.9129 81.045 28.9771 81.0018 29.0236 80.9423C29.0701 80.8827 29.0965 80.8099 29.0989 80.7344C29.1785 78.6998 29.0349 66.2133 30.3833 61.2775C30.4521 61.0279 30.6047 60.8095 30.8154 60.6591L33.4269 58.799L33.6275 55.791L26.4827 56.7074Z",
    fill: "url(#paint10_linear_2420_29580)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7065 40.1542C31.369 40.0818 26.5828 41.2926 26.5828 41.2926C25.2901 48.8362 26.3573 57.5385 26.3573 57.5385C29.7142 58.4193 33.5033 56.9996 33.5033 56.9996C34.0612 53.8468 36.6644 44.9724 36.6644 44.9724C38.7845 44.7089 40.5306 44.0976 41.9681 43.2892C40.8713 42.0179 40.3537 40.4011 40.1294 39.4443C38.5957 39.9215 37.0443 40.1756 35.7065 40.1542Z",
    fill: "#D86A82"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5178 33.7646C48.4083 33.6206 48.2548 33.5162 48.0806 33.4674C47.9064 33.4185 47.7211 33.4279 47.5527 33.494C46.9141 36.1897 43.5678 38.3763 40.1289 39.4446C40.3533 40.4014 40.8708 42.0181 41.9676 43.2895C47.6738 40.0809 48.5178 33.7646 48.5178 33.7646Z",
    fill: "url(#paint11_linear_2420_29580)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2483 45.4927L26.5865 41.293C26.5865 41.293 22.5351 44.0457 21.8691 47.5356C23.093 47.6246 24.2885 47.9469 25.3911 48.4853C25.6879 46.8317 28.2483 45.4927 28.2483 45.4927Z",
    fill: "#D86A82"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3143 36.6328L29.9338 40.6237C29.9227 40.6556 29.9232 40.6905 29.9351 40.7221C29.947 40.7538 29.9696 40.7803 29.999 40.797C30.3753 41.0059 31.731 41.6065 33.3643 40.5714C33.4485 40.5184 33.5201 40.4475 33.574 40.3638C33.628 40.2802 33.6629 40.1857 33.6765 40.0871L34.1228 36.6328H31.3143Z",
    fill: "url(#paint12_linear_2420_29580)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3167 32.9355C34.3167 32.9355 35.8326 35.7845 35.6379 36.9418C35.4432 38.0992 33.5653 38.0102 31.926 37.0748L30.7793 33.9885L34.3167 32.9355Z",
    fill: "url(#paint13_linear_2420_29580)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9986 35.5629C32.0141 35.5558 32.0279 35.5456 32.0391 35.5327C32.0503 35.5199 32.0586 35.5048 32.0634 35.4885C32.0683 35.4721 32.0695 35.455 32.0671 35.4381C32.0648 35.4212 32.0588 35.4051 32.0496 35.3907C31.8617 35.1171 31.7193 34.8149 31.6282 34.4957C31.6282 34.4957 31.3552 34.3212 32.3214 34.0897C33.2877 33.8583 34.7276 33.4962 35.0303 32.6771C35.3258 31.8759 34.5554 29.8603 33.3126 31.4664C33.3015 31.4804 33.2873 31.4918 33.2712 31.4996C33.2551 31.5075 33.2374 31.5115 33.2194 31.5115C33.2015 31.5115 33.1838 31.5075 33.1677 31.4996C33.1515 31.4918 33.1374 31.4804 33.1262 31.4664C32.9233 31.2028 32.3903 30.6544 31.6496 30.9915C30.9575 31.3025 30.8792 31.8094 30.8887 32.0599C30.8889 32.0773 30.8853 32.0946 30.8781 32.1105C30.871 32.1264 30.8604 32.1405 30.8471 32.1518C30.8338 32.1632 30.8182 32.1715 30.8014 32.1761C30.7846 32.1807 30.767 32.1815 30.7498 32.1786C30.3996 32.1121 29.5627 32.0599 29.1663 32.9169C28.8434 33.6292 29.0476 34.0292 29.2446 34.2227C29.2584 34.2372 29.2683 34.2551 29.2733 34.2745C29.2784 34.2939 29.2784 34.3143 29.2734 34.3338C29.2685 34.3532 29.2586 34.3711 29.2449 34.3857C29.2311 34.4003 29.2139 34.4112 29.1947 34.4173C28.9645 34.4886 28.6677 34.6833 28.6974 35.2234C28.7377 35.9688 29.5722 35.9023 29.8096 35.8691C29.8287 35.8663 29.8482 35.8682 29.8664 35.8746C29.8846 35.881 29.901 35.8917 29.9141 35.9059C30.1171 36.1314 31.0347 37.093 32.027 37.2022C32.0464 37.2032 32.0657 37.1995 32.0833 37.1913C32.1009 37.1831 32.1162 37.1708 32.128 37.1553C32.1397 37.1398 32.1474 37.1217 32.1505 37.1026C32.1536 37.0835 32.152 37.0638 32.1457 37.0455L31.7172 35.7979C31.7075 35.7699 31.7085 35.7393 31.7201 35.7121C31.7318 35.6849 31.7532 35.663 31.7801 35.6507L31.9986 35.5629Z",
    fill: "url(#paint14_linear_2420_29580)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1693 35.7395C32.1693 35.7395 31.0903 34.9988 31.0119 35.6208C30.9336 36.2428 31.9877 36.5277 32.5041 36.2903L32.1693 35.7395Z",
    fill: "url(#paint15_linear_2420_29580)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.388 48.4799C25.388 48.4799 23.9719 54.8674 25.2539 58.4595C23.6823 59.1883 23.9719 59.053 23.9719 59.053C23.9719 59.053 20.8606 49.9638 21.8661 47.5386C23.8461 47.3297 24.8278 47.8579 25.388 48.4799Z",
    fill: "url(#paint16_linear_2420_29580)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2546 58.46C25.2546 58.46 26.0653 59.5093 26 59.926C25.9348 60.3426 25.9205 60.5195 25.9205 60.5195C25.9205 60.5195 25.5134 60.2405 25.5383 59.8844C25.5953 61.0145 25.9727 62.2989 25.6297 62.2371C25.2866 62.1754 23.5061 60.5349 23.9085 58.7864C24.8213 58.1478 25.0777 58.2166 25.2546 58.46Z",
    fill: "url(#paint17_linear_2420_29580)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4692 140.406C43.3473 140.406 43.2305 140.358 43.1443 140.272C43.0582 140.186 43.0098 140.069 43.0098 139.947V85.0697C43.0098 84.9479 43.0582 84.8311 43.1443 84.7449C43.2305 84.6587 43.3473 84.6104 43.4692 84.6104C43.591 84.6104 43.7078 84.6587 43.794 84.7449C43.8801 84.8311 43.9285 84.9479 43.9285 85.0697V139.947C43.9285 140.069 43.8801 140.186 43.794 140.272C43.7078 140.358 43.591 140.406 43.4692 140.406Z",
    fill: "url(#paint18_linear_2420_29580)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0258 140.406C30.904 140.406 30.7871 140.358 30.701 140.272C30.6148 140.186 30.5664 140.069 30.5664 139.947V85.0697C30.5664 84.9479 30.6148 84.8311 30.701 84.7449C30.7871 84.6587 30.904 84.6104 31.0258 84.6104C31.1476 84.6104 31.2645 84.6587 31.3506 84.7449C31.4368 84.8311 31.4852 84.9479 31.4852 85.0697V139.947C31.4852 140.069 31.4368 140.186 31.3506 140.272C31.2645 140.358 31.1476 140.406 31.0258 140.406Z",
    fill: "url(#paint19_linear_2420_29580)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0.459291 140.751C0.397663 140.751 0.336672 140.738 0.280045 140.714C0.224479 140.69 0.17409 140.656 0.131766 140.613C0.0894424 140.57 0.0560176 140.519 0.0334094 140.463C0.0108012 140.408 -0.000544732 140.348 2.00976e-05 140.287C0.000584928 140.227 0.0130509 140.167 0.0367023 140.112L23.5141 84.8906C23.5349 84.8315 23.5676 84.7773 23.6102 84.7313C23.6527 84.6854 23.7042 84.6486 23.7615 84.6232C23.8188 84.5979 23.8806 84.5846 23.9433 84.584C24.0059 84.5834 24.068 84.5957 24.1257 84.62C24.1834 84.6443 24.2356 84.6802 24.2789 84.7254C24.3223 84.7706 24.3559 84.8242 24.3778 84.8829C24.3997 84.9416 24.4093 85.0042 24.4061 85.0667C24.4029 85.1293 24.387 85.1905 24.3593 85.2467L0.881879 140.475C0.845983 140.557 0.78685 140.627 0.711763 140.676C0.636675 140.725 0.548915 140.751 0.459291 140.751Z",
    fill: "url(#paint20_linear_2420_29580)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9612 140.751C14.8996 140.751 14.8386 140.738 14.782 140.714C14.7264 140.69 14.676 140.656 14.6337 140.613C14.5914 140.57 14.558 140.519 14.5354 140.463C14.5128 140.408 14.5014 140.348 14.502 140.287C14.5025 140.227 14.515 140.167 14.5387 140.112L38.0161 84.8906C38.0369 84.8315 38.0696 84.7773 38.1121 84.7313C38.1547 84.6854 38.2062 84.6486 38.2635 84.6232C38.3207 84.5979 38.3826 84.5846 38.4452 84.584C38.5079 84.5834 38.5699 84.5957 38.6277 84.62C38.6854 84.6443 38.7375 84.6802 38.7809 84.7254C38.8242 84.7706 38.8579 84.8242 38.8798 84.8829C38.9016 84.9416 38.9113 85.0042 38.9081 85.0667C38.9049 85.1293 38.889 85.1905 38.8612 85.2467L15.3838 140.475C15.3479 140.557 15.2888 140.627 15.2137 140.676C15.1386 140.725 15.0509 140.751 14.9612 140.751Z",
    fill: "url(#paint21_linear_2420_29580)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4946 84.2803H22.3609C22.1767 84.2803 22.0273 84.4296 22.0273 84.6138V85.2406C22.0273 85.4248 22.1767 85.5741 22.3609 85.5741H44.4946C44.6788 85.5741 44.8281 85.4248 44.8281 85.2406V84.6138C44.8281 84.4296 44.6788 84.2803 44.4946 84.2803Z",
    fill: "url(#paint22_linear_2420_29580)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M34.891 93.9735H20.3461C20.2243 93.9735 20.1074 93.9251 20.0213 93.8389C19.9351 93.7528 19.8867 93.6359 19.8867 93.5141C19.8867 93.3922 19.9351 93.2754 20.0213 93.1892C20.1074 93.1031 20.2243 93.0547 20.3461 93.0547H34.891C35.0128 93.0547 35.1297 93.1031 35.2158 93.1892C35.302 93.2754 35.3504 93.3922 35.3504 93.5141C35.3504 93.6359 35.302 93.7528 35.2158 93.8389C35.1297 93.9251 35.0128 93.9735 34.891 93.9735Z",
    fill: "url(#paint23_linear_2420_29580)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4296 103.5H15.8848V104.419H30.4296V103.5Z",
    fill: "url(#paint24_linear_2420_29580)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1093 113.943H11.5645V114.862H26.1093V113.943Z",
    fill: "url(#paint25_linear_2420_29580)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5785 125.307H7.03361C6.91177 125.307 6.79492 125.259 6.70877 125.173C6.62262 125.087 6.57422 124.97 6.57422 124.848C6.57422 124.726 6.62262 124.609 6.70877 124.523C6.79492 124.437 6.91177 124.389 7.03361 124.389H21.5785C21.7003 124.389 21.8172 124.437 21.9033 124.523C21.9895 124.609 22.0379 124.726 22.0379 124.848C22.0379 124.97 21.9895 125.087 21.9033 125.173C21.8172 125.259 21.7003 125.307 21.5785 125.307Z",
    fill: "url(#paint26_linear_2420_29580)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1976 135.752H2.65275C2.53091 135.752 2.41406 135.703 2.32791 135.617C2.24176 135.531 2.19336 135.414 2.19336 135.292C2.19336 135.171 2.24176 135.054 2.32791 134.968C2.41406 134.881 2.53091 134.833 2.65275 134.833H17.1976C17.3195 134.833 17.4363 134.881 17.5225 134.968C17.6086 135.054 17.657 135.171 17.657 135.292C17.657 135.414 17.6086 135.531 17.5225 135.617C17.4363 135.703 17.3195 135.752 17.1976 135.752Z",
    fill: "url(#paint27_linear_2420_29580)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M143.249 87.9469C143.249 87.9469 137.432 95.398 144.069 102.977L146.562 102.74C146.562 102.74 141.756 95.024 143.897 88.8728L147.433 89.1304L149.388 87.8555L143.249 87.9469Z",
    fill: "url(#paint28_linear_2420_29580)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M126.084 71.1899L153.721 69.7654C154.262 69.7369 154.719 70.0645 154.734 70.4919L155.359 87.2292C155.375 87.6601 154.94 88.0234 154.394 88.0352C149.39 88.1397 127.176 88.6098 126.198 88.6857C125.22 88.7617 125.158 75.2982 125.154 71.9769C125.154 71.5661 125.564 71.2207 126.084 71.1899Z",
    fill: "url(#paint29_linear_2420_29580)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M126.641 88.0789L126.622 88.0088C126.205 86.4787 125.931 80.1743 125.924 71.9612C125.928 71.9115 125.951 71.8653 125.988 71.8322C126.025 71.799 126.073 71.7814 126.123 71.7831L153.76 70.3587C153.809 70.3563 153.858 70.3701 153.899 70.3978C153.921 70.4126 153.939 70.4324 153.952 70.4555C153.965 70.4786 153.972 70.5044 153.973 70.5308L154.597 87.2681C154.596 87.3185 154.575 87.3664 154.539 87.4015C154.502 87.4365 154.454 87.456 154.403 87.4557C150.421 87.54 130.372 87.9637 126.725 88.0848L126.641 88.0789ZM153.768 70.5367H153.762L126.127 71.9612C126.119 71.9615 126.111 71.964 126.104 71.9683C126.115 80.0402 126.378 86.2568 126.781 87.8878C130.616 87.7631 150.43 87.3453 154.387 87.261H154.393C154.396 87.2612 154.399 87.2607 154.402 87.2594C154.405 87.2582 154.407 87.2563 154.409 87.2539L153.781 70.532C153.781 70.532 153.781 70.5367 153.768 70.5367Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M144.148 73.1297C144.166 73.5535 144.323 73.8906 144.496 73.8823L152.179 73.5404C152.352 73.5321 152.478 73.1843 152.459 72.7605C152.44 72.3368 152.284 71.9997 152.11 72.008L144.429 72.3498C144.254 72.3581 144.129 72.7071 144.148 73.1297Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M144.183 75.2141C144.179 75.3067 144.211 75.3969 144.273 75.4659C144.335 75.5348 144.421 75.5769 144.514 75.5833L152.195 75.2414C152.283 75.2195 152.36 75.1681 152.414 75.0957C152.468 75.0234 152.495 74.9346 152.491 74.8445C152.487 74.7543 152.453 74.6682 152.393 74.6008C152.332 74.5334 152.251 74.4889 152.162 74.4746L144.479 74.8177C144.388 74.8323 144.306 74.8819 144.251 74.9559C144.195 75.0299 144.171 75.1225 144.183 75.2141Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M144.183 76.8096C144.179 76.9021 144.211 76.9924 144.273 77.0613C144.335 77.1303 144.421 77.1724 144.514 77.1788L152.195 76.8369C152.283 76.8156 152.361 76.7644 152.415 76.6921C152.47 76.6198 152.497 76.5308 152.493 76.4404C152.489 76.35 152.454 76.2638 152.394 76.1965C152.333 76.1292 152.251 76.0849 152.162 76.0713L144.479 76.4132C144.388 76.4278 144.306 76.4774 144.251 76.5514C144.195 76.6253 144.171 76.718 144.183 76.8096Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M133.655 86.0941H133.348C133.258 86.0935 133.171 86.06 133.104 85.9998C133.037 85.9397 132.995 85.8571 132.985 85.7677L132.315 80.001C132.309 79.9528 132.313 79.9039 132.327 79.8572C132.34 79.8105 132.363 79.767 132.393 79.7292C132.424 79.6913 132.461 79.6597 132.503 79.6363C132.546 79.6129 132.592 79.5981 132.64 79.5927C132.998 79.5426 133.341 79.418 133.648 79.2271C133.8 79.1273 133.976 78.6632 134.13 78.2537C134.367 77.6222 134.665 76.8292 135.211 76.212C136.096 75.2006 135.949 73.6824 135.924 73.5126C135.88 73.1399 136.168 72.5927 136.618 72.417C136.893 72.3101 137.449 72.2555 138.043 73.0865C138.792 74.1239 138.465 75.5223 138.248 76.447C138.184 76.6854 138.137 76.9282 138.109 77.1735V77.1901C138.297 77.3088 139.148 77.177 139.659 77.0975C139.93 77.056 140.21 77.012 140.483 76.9788C141.433 76.8684 142.554 76.9099 142.763 78.2192C142.797 78.4356 142.781 78.6568 142.715 78.8658C142.65 79.0747 142.537 79.2658 142.386 79.4241C142.806 79.7802 143.025 80.1767 143.035 80.5957C143.034 80.9292 142.917 81.252 142.704 81.5086C142.883 81.6697 143.017 81.8753 143.091 82.1045C143.166 82.3338 143.178 82.5786 143.128 82.8143C143.057 83.1538 142.88 83.462 142.622 83.6939C142.762 83.8499 142.837 84.0532 142.832 84.2625C142.814 84.9011 142.044 85.5398 140.999 85.7795C139.742 86.0739 134.936 86.0941 133.655 86.0941ZM133.085 80.255L133.679 85.3593C134.966 85.3593 139.675 85.3356 140.844 85.0673C141.675 84.8762 142.101 84.4382 142.106 84.2471C142.106 84.1723 141.97 84.0833 141.762 84.0227C141.679 83.9985 141.608 83.9465 141.561 83.8756C141.513 83.8046 141.491 83.7193 141.499 83.6341C141.508 83.549 141.545 83.4694 141.606 83.409C141.667 83.3487 141.746 83.3113 141.832 83.3034C142.084 83.2796 142.352 82.9924 142.416 82.6742C142.462 82.444 142.423 82.1211 141.975 81.8849C141.92 81.8556 141.873 81.8126 141.839 81.76C141.805 81.7075 141.785 81.647 141.781 81.5845C141.776 81.5219 141.787 81.459 141.814 81.4022C141.841 81.3454 141.882 81.2966 141.934 81.2605C141.934 81.2605 142.319 80.9661 142.309 80.6135C142.298 80.261 141.921 79.9583 141.607 79.7565C141.554 79.7225 141.51 79.6754 141.481 79.6196C141.451 79.5638 141.436 79.5013 141.438 79.4381C141.439 79.375 141.457 79.3133 141.489 79.259C141.522 79.2048 141.568 79.1598 141.623 79.1285C141.64 79.1178 142.125 78.8235 142.046 78.338C141.988 77.9712 141.928 77.5569 140.577 77.7124C140.319 77.7421 140.046 77.7848 139.782 77.8252C138.8 77.9783 138.024 78.0982 137.615 77.7302C137.532 77.6566 137.467 77.5646 137.426 77.4616C137.385 77.3585 137.368 77.2473 137.378 77.1367C137.407 76.8471 137.46 76.5605 137.536 76.2796C137.733 75.4368 138.002 74.283 137.449 73.5174C137.234 73.2194 137.023 73.058 136.896 73.0995C136.833 73.1338 136.779 73.1821 136.738 73.2405C136.697 73.2989 136.67 73.366 136.658 73.4366C136.681 73.6313 136.857 75.4475 135.762 76.6963C135.305 77.2198 135.05 77.9071 134.813 78.5136C134.575 79.1202 134.398 79.6093 134.048 79.8408C133.752 80.031 133.427 80.171 133.085 80.255Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M146.436 124.431C146.436 124.431 151.152 134.709 153.625 138.966C153.625 138.966 154.117 141.644 153.625 142.487L153.206 142.673L155.162 142.615C155.162 142.615 155.335 139.011 155.2 138.816C155.151 138.755 155.089 138.707 155.018 138.674C154.948 138.641 154.87 138.626 154.792 138.629C154.792 138.629 153.954 131.988 151.527 130.572L149.175 122.471L146.436 124.431Z",
    fill: "url(#paint30_linear_2420_29580)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M152.373 143.177C152.373 143.225 153.9 143.202 154.729 143.188C154.878 143.185 155.022 143.132 155.137 143.038C155.252 142.943 155.332 142.813 155.363 142.667L155.99 139.372C156.018 139.221 155.987 139.065 155.904 138.937C155.82 138.809 155.689 138.718 155.54 138.683L155.184 138.603C155.184 138.603 154.685 139.289 154.842 139.933C154.999 140.578 155.139 142.249 154.742 142.444C154.346 142.638 153.199 142.673 153.199 142.673C153.199 142.673 152.399 142.752 152.373 143.177Z",
    fill: "url(#paint31_linear_2420_29580)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M141.967 143.236C141.934 143.255 141.908 143.285 141.894 143.32C141.879 143.355 141.877 143.394 141.887 143.431C141.897 143.467 141.918 143.5 141.948 143.523C141.978 143.546 142.015 143.559 142.053 143.559C143.443 143.545 146.564 143.501 146.835 143.386C147.191 143.237 146.705 141.953 146.191 141.519L143.359 142.443L141.967 143.236Z",
    fill: "url(#paint32_linear_2420_29580)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M141.088 123.776C141.088 123.776 144.135 138.518 144.997 141.395L142.957 142.674C142.957 142.674 143.98 142.5 144.738 142.445C145.497 142.39 146.192 141.52 146.192 141.52L145.955 141.131C145.955 141.131 145.19 126.47 145.376 124.804L141.088 123.776Z",
    fill: "url(#paint33_linear_2420_29580)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M133.523 89.3893C133.523 89.3893 133.103 97.0576 140.085 100.976L138.404 104.81C138.404 104.81 132.083 100.987 132.317 90.5656C132.323 90.266 132.217 89.9749 132.021 89.749L130.677 88.1904C130.423 87.8977 130.244 87.5485 130.154 87.1721C130.064 86.7957 130.066 86.4032 130.159 86.0276L130.336 85.3153C130.35 85.2601 130.376 85.2087 130.413 85.1654C130.45 85.1221 130.497 85.088 130.549 85.0659C130.601 85.0437 130.658 85.0342 130.715 85.0379C130.772 85.0416 130.827 85.0586 130.876 85.0874L131.016 85.1681C131.464 85.4282 131.818 85.8223 132.029 86.2947L132.689 87.769C132.809 88.0374 133.01 88.2617 133.264 88.4106C133.518 88.5595 133.812 88.6257 134.105 88.5999L134.512 88.5643L133.523 89.3893Z",
    fill: "url(#paint34_linear_2420_29580)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M139.842 100.402C141.01 100.726 144.968 101.767 147.439 101.724L145.922 110.284L146.041 111.68L141.096 111.657C141.096 111.657 139.703 108.425 138.603 106.813C138.286 106.347 138.521 105.792 138.701 105.258L138.454 105.093C138.332 105.012 138.24 104.892 138.192 104.754C138.143 104.615 138.142 104.464 138.187 104.325L139.392 100.645C139.421 100.554 139.484 100.477 139.568 100.432C139.652 100.386 139.75 100.376 139.842 100.402Z",
    fill: "url(#paint35_linear_2420_29580)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M140.701 110.928L140.798 111.773C140.798 111.773 139.401 115.959 141.497 125.734C141.497 125.734 146.036 127.021 149.768 123.943C149.768 123.943 148.716 114.716 148.428 114.286C146.997 112.149 146.042 111.675 146.042 111.675L146 110.751C146 110.751 142.008 111.477 140.701 110.928Z",
    fill: "url(#paint36_linear_2420_29580)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M142.635 101.091C142.617 101.069 143.668 97.9219 143.668 97.9219L145.171 98.0584L145.764 101.628C145.764 101.628 143.402 102.104 142.635 101.091Z",
    fill: "url(#paint37_linear_2420_29580)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M144.812 92.9599C144.712 93.0228 141.599 94.3096 142.268 97.5407C142.287 97.6349 142.328 97.7233 142.388 97.7984C142.448 97.8736 142.525 97.9334 142.612 97.9728C143.432 98.3371 144.331 98.4863 145.224 98.4061C146.854 98.2411 147.923 95.3946 147.877 94.5672C147.831 93.7398 145.805 92.3415 144.812 92.9599Z",
    fill: "url(#paint38_linear_2420_29580)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M145.759 91.7041C145.677 91.7148 143.96 92.3131 144.809 93.5571C145.658 94.8011 145.98 95.5335 145.577 96.0796C145.21 96.5781 144.397 96.2944 144.468 97.3295C144.477 97.4309 144.458 97.5328 144.415 97.625C144.372 97.7171 144.305 97.7961 144.221 97.8542C143.454 98.3729 141.586 99.9695 143.438 102.246C143.513 102.335 143.559 102.445 143.57 102.56C143.582 102.676 143.559 102.792 143.503 102.894C142.961 103.868 141.821 106.717 145.946 108.298C150.02 109.86 151.492 107.196 151.903 106.131C151.947 106.02 152.025 105.926 152.126 105.862C152.227 105.798 152.346 105.768 152.465 105.775C152.913 105.796 153.548 105.722 153.518 105.124C153.5 104.759 153.274 104.434 153.005 104.174C152.943 104.113 152.896 104.039 152.867 103.956C152.838 103.874 152.829 103.787 152.84 103.7C152.85 103.614 152.88 103.531 152.928 103.458C152.976 103.385 153.04 103.324 153.115 103.28C153.249 103.209 153.366 103.11 153.461 102.992C153.556 102.873 153.625 102.736 153.664 102.589C153.911 101.674 153.419 98.938 150.795 98.4738C150.68 98.4497 150.575 98.3933 150.49 98.3114C150.406 98.2294 150.347 98.1252 150.32 98.0109C150.32 98.0109 150.32 98.0037 150.32 98.0002C150.3 97.897 150.309 97.7903 150.346 97.6919C150.383 97.5936 150.447 97.5075 150.53 97.4435C150.949 97.136 151.487 96.5176 151.05 95.5252C150.663 94.6456 149.921 94.3488 149.371 94.2551C149.294 94.2435 149.22 94.2163 149.154 94.1751C149.087 94.1339 149.03 94.0796 148.986 94.0156C148.941 93.9516 148.91 93.8791 148.895 93.8027C148.879 93.7263 148.88 93.6476 148.896 93.5713C149.085 92.6905 148.922 91.2886 145.759 91.7041Z",
    fill: "url(#paint39_linear_2420_29580)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2420_29580",
    x1: 27.8709,
    y1: -0.108519,
    x2: 178.001,
    y2: 43.5024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D86A82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D86A82",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2420_29580",
    x1: 123.894,
    y1: 116.776,
    x2: 109.734,
    y2: 128.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2420_29580",
    x1: 122.271,
    y1: 118.083,
    x2: 111.317,
    y2: 127.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2420_29580",
    x1: 49.7003,
    y1: 29.456,
    x2: 46.8039,
    y2: 37.7333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2420_29580",
    x1: 47.4738,
    y1: 34.7442,
    x2: 49.6568,
    y2: 30.3426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2420_29580",
    x1: 45.6147,
    y1: 73.3512,
    x2: 36.7119,
    y2: 82.6101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2420_29580",
    x1: 33.373,
    y1: 81.2022,
    x2: 35.0147,
    y2: 81.2022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2420_29580",
    x1: -234.33,
    y1: 385.538,
    x2: -279.561,
    y2: 439.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2420_29580",
    x1: 41.6439,
    y1: 69.534,
    x2: 32.7411,
    y2: 78.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2420_29580",
    x1: 27.4551,
    y1: 81.118,
    x2: 28.8736,
    y2: 81.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2420_29580",
    x1: -236.846,
    y1: 383.424,
    x2: -282.077,
    y2: 437.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2420_29580",
    x1: 47.2239,
    y1: 28.5891,
    x2: 44.3275,
    y2: 36.8664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A570"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2420_29580",
    x1: 29.9254,
    y1: 38.8965,
    x2: 34.1228,
    y2: 38.8965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2420_29580",
    x1: 35.9142,
    y1: 37.5736,
    x2: 31.2713,
    y2: 34.7434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2420_29580",
    x1: 28.8135,
    y1: 31.7611,
    x2: 34.8117,
    y2: 36.4955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2420_29580",
    x1: 34.6935,
    y1: 38.6295,
    x2: 30.5165,
    y2: 36.0843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2420_29580",
    x1: 26.4101,
    y1: 69.7578,
    x2: 22.9985,
    y2: 45.2512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2420_29580",
    x1: 26.0048,
    y1: 67.4008,
    x2: 23.2817,
    y2: 47.8442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2420_29580",
    x1: 56.7225,
    y1: 97.4174,
    x2: -17.4691,
    y2: 181.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2420_29580",
    x1: 49.6968,
    y1: 91.2483,
    x2: -24.4948,
    y2: 175.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2420_29580",
    x1: 9.98059,
    y1: 186.294,
    x2: 10.7332,
    y2: 161.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2420_29580",
    x1: 24.4695,
    y1: 186.731,
    x2: 25.2209,
    y2: 161.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2420_29580",
    x1: 30.3272,
    y1: 187.843,
    x2: 31.0857,
    y2: 162.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2420_29580",
    x1: 24.8106,
    y1: 186.741,
    x2: 25.562,
    y2: 161.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2420_29580",
    x1: 20.6686,
    y1: 186.618,
    x2: 21.42,
    y2: 161.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2420_29580",
    x1: 16.6652,
    y1: 186.496,
    x2: 17.4166,
    y2: 161.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2420_29580",
    x1: 12.4525,
    y1: 186.369,
    x2: 13.2051,
    y2: 161.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2420_29580",
    x1: 8.38974,
    y1: 186.246,
    x2: 9.14233,
    y2: 161.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2420_29580",
    x1: 147.322,
    y1: 86.9984,
    x2: 143.138,
    y2: 99.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2420_29580",
    x1: 160.18,
    y1: 64.4344,
    x2: 130.267,
    y2: 87.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2420_29580",
    x1: 146.436,
    y1: 132.569,
    x2: 155.251,
    y2: 132.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2420_29580",
    x1: 152.373,
    y1: 141.394,
    x2: 156,
    y2: 141.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996597"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D56981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2420_29580",
    x1: 141.881,
    y1: 142.756,
    x2: 146.957,
    y2: 142.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996597"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D56981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2420_29580",
    x1: 141.088,
    y1: 133.224,
    x2: 146.192,
    y2: 133.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2420_29580",
    x1: 130.092,
    y1: 94.9245,
    x2: 140.085,
    y2: 94.9245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2420_29580",
    x1: 141.043,
    y1: 100.358,
    x2: 159.779,
    y2: 137.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C246D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2420_29580",
    x1: 140.342,
    y1: 119.998,
    x2: 149.769,
    y2: 119.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996597"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D56981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2420_29580",
    x1: 142.635,
    y1: 99.8307,
    x2: 145.758,
    y2: 99.8307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2420_29580",
    x1: 147.6,
    y1: 95.7946,
    x2: 170.337,
    y2: 97.3401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2420_29580",
    x1: 151.336,
    y1: 94.4236,
    x2: 143.333,
    y2: 110.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.9ab16c0090ee8f6d8e38e7d16320bd5b.svg";
export { ForwardRef as ReactComponent };